import "core-js/modules/es.array.includes.js";

/*
 * @Author: 邓鹏
 * @Date: 2026-03-20 16:14:14
 * @LastEditors: 邓鹏
 * @LastEditTime: 2026-06-30 16:26:37
 * @FilePath: /marketing-landing-fe/src/const/enums.ts
 * @Description: 环境相关枚举配置
 */
import { APP_NAME, envFactory, envName, isDebugEnv } from './base';
var TINMAN_BASE_C_URL = envFactory('TINMAN_BASE_C_URL') || '';
var JOJO_READ_URL = envFactory('JOJO_READ_URL') || '';
/** iOS 设备检测 */

var isIOSDevice = /iPhone|iPod|iPad|Macintosh/.test(navigator.userAgent);
/** 是否在 JOJOUP APP 内（检测 UA 中的 JoJoAppFrom/flawless 标识） */

var isInJoJoUpApp = function () {
  var ua = window.navigator.userAgent;
  var isJoJoBrowser = /JoJoVersion|JoJoWebViewSymbol/i.test(ua) && !/sherlock/gim.test(ua);
  return isJoJoBrowser && /JoJoAppFrom\/flawless/i.test(ua);
}();

export var isJoJoUpMaskIos = !isInJoJoUpApp && isIOSDevice;
/**
 * 根据当前 APP_NAME 从配置映射中取值
 * @param configMap 各应用的配置映射
 * @returns 当前应用对应的配置值
 */

export var getEnvConfig = function getEnvConfig(configMap) {
  var _a, _b, _c;

  var validAppNames = ['jojoup', 'beans', 'jojo', 'matrix', 'zzx', 'doudou'];

  if (validAppNames.includes(APP_NAME)) {
    var appName = APP_NAME;

    if (appName === 'zzx' && !configMap.zzx) {
      return (_a = configMap.jojoup) !== null && _a !== void 0 ? _a : configMap.jojo;
    }

    if (appName === 'doudou' && !configMap.doudou) {
      return (_b = configMap.beans) !== null && _b !== void 0 ? _b : configMap.jojo;
    }

    return (_c = configMap[appName]) !== null && _c !== void 0 ? _c : configMap.jojo;
  }

  return configMap.jojo;
};
/** 小程序基础配置（按环境区分） */

var getMiniProgramInfo = function getMiniProgramInfo() {
  var isProd = !isDebugEnv;
  return {
    jojoup: isProd ? {
      userName: 'gh_cea7a551d1dc',
      miniProgramType: 0,
      miniProgram: 'mapp.mohezi.jojoupLite'
    } : {
      userName: 'gh_283615a01678',
      miniProgramType: 2,
      miniProgram: 'jojo.learning.paradise'
    },
    beans: isProd ? {
      userName: 'gh_ef0f0e30ef89',
      miniProgramType: 0,
      miniProgram: 'jojo_read'
    } : {
      userName: 'gh_87f2400c676b',
      miniProgramType: 2,
      miniProgram: 'mapp_shusheng_JoJoRead'
    },
    doudou: isProd ? {
      userName: 'gh_ef0f0e30ef89',
      miniProgramType: 0,
      miniProgram: 'jojo_read'
    } : {
      userName: 'gh_87f2400c676b',
      miniProgramType: 2,
      miniProgram: 'mapp_shusheng_JoJoRead'
    },
    jojo: isProd ? {
      userName: 'gh_ef0f0e30ef89',
      miniProgramType: 0,
      miniProgram: 'jojo_read'
    } : {
      userName: 'gh_87f2400c676b',
      miniProgramType: 2,
      miniProgram: 'mapp_shusheng_JoJoRead'
    }
  };
};

var jojoupApiDomain = TINMAN_BASE_C_URL || window.location.origin; // 女娲配置

var getNvwaConfig = function getNvwaConfig() {
  return {
    jojoup: {
      env: envName || 'pro',
      appKey: 'ASAFVV8E5UZ',
      scene: 'app',
      appSecret: 'afe7c57beaf03a68',
      baseTwURL: TINMAN_BASE_C_URL
    },
    jojo: {
      env: envName || 'pro',
      appKey: 'D04JBD',
      scene: 'h5',
      appSecret: 'b4f6b6d27637d32f',
      baseTwURL: TINMAN_BASE_C_URL
    },
    beans: {
      env: envName || 'pro',
      appKey: 'D04JBD',
      scene: 'h5',
      appSecret: 'b4f6b6d27637d32f',
      baseTwURL: TINMAN_BASE_C_URL
    },
    doudou: {
      env: envName || 'pro',
      appKey: 'D04JBD',
      scene: 'h5',
      appSecret: 'b4f6b6d27637d32f',
      baseTwURL: TINMAN_BASE_C_URL
    }
  };
};
/** 账号配置 */


var getAccountConfig = function getAccountConfig() {
  return {
    jojoup: {
      envName: envName,
      appName: APP_NAME,
      hosts: {
        ucHost: "".concat(jojoupApiDomain, "/uc/r"),
        serverHost: "".concat(jojoupApiDomain, "/read"),
        apiHost: jojoupApiDomain
      }
    },
    jojo: {
      envName: envName,
      appName: APP_NAME
    },
    beans: {
      // 补充 beans 的账号配置
      envName: envName,
      appName: APP_NAME,
      hosts: {
        ucHost: TINMAN_BASE_C_URL,
        serverHost: JOJO_READ_URL,
        apiHost: TINMAN_BASE_C_URL
      }
    },
    doudou: {
      // 补充 beans 的账号配置
      envName: envName,
      appName: APP_NAME,
      hosts: {
        ucHost: TINMAN_BASE_C_URL,
        serverHost: JOJO_READ_URL,
        apiHost: TINMAN_BASE_C_URL
      }
    },
    zzx: {
      envName: envName,
      appName: APP_NAME,
      hosts: {
        ucHost: "".concat(TINMAN_BASE_C_URL, "/uc/r"),
        serverHost: JOJO_READ_URL,
        apiHost: TINMAN_BASE_C_URL
      }
    }
  };
}; // APP路由配置


export var getAppSchema = function getAppSchema() {
  return {
    jojoup: {
      home: 'box-router://com.read.box.book/course_home/home',
      course: 'box-router://com.read.box.book/course_home/home',
      study: 'box-router://com.read.box.book/course_home/home',
      downloadUrl: 'https://pages.mohezi.cn/read/account/appDownload/?packageName=com.read.box.book',
      webview: 'box-router://com.read.box.book/webview'
    },
    zzx: {
      home: 'echo-router://com.f2so.echo/home',
      course: 'echo-router://com.f2so.echo/home/course',
      study: 'echo-router://com.f2so.echo/home/course',
      downloadUrl: 'https://pages.mohezi.cn/read/account/appDownload?packageName=com.read.box.book'
    },
    beans: {
      home: 'beans-router://cn.mohezi.beans/home/square',
      study: 'beans-router://cn.mohezi.beans/home/course',
      course: 'beans-router://cn.mohezi.beans/course/allCourse',
      downloadUrl: 'https://jojoread.tinman.cn/account/appDownload?packageName=com.shusheng.JoJoRead&channel=Tinman'
    },
    doudou: {
      home: 'pico-router://com.tinkzo.pico/home/square',
      study: 'pico-router://com.tinkzo.pico/home/course',
      course: 'pico-router://com.tinkzo.pico/course/allCourse',
      downloadUrl: isIOSDevice ? 'https://pages.dd.shushengdu.com/read/account/appDownload/?packageName=com.tinkzo.pico' : 'https://shushengdu.com'
    },
    jojo: {
      home: 'tinman-router://cn.tinman.jojoread/home/square',
      study: 'tinman-router://cn.tinman.jojoread/home/course',
      course: 'tinman-router://cn.tinman.jojoread/course/allCourse',
      downloadUrl: 'https://jojoread.tinman.cn/account/appDownload?packageName=com.shusheng.JoJoRead&channel=Tinman',
      webview: 'tinman-router://cn.tinman.jojoread/webview'
    }
  };
};
export var envConfigMap = {
  // 路径配置
  addTeacherPath: {
    jojoup: '/mall/market',
    beans: '',
    doudou: '',
    jojo: ''
  },
  // 本地基础URL
  localBaseUrl: {
    jojoup: "".concat(window.location.origin, "/mall/landing/qwerup"),
    beans: "".concat(window.location.origin, "/act2/qwerup"),
    doudou: "".concat(window.location.origin, "/act2/qwerup"),
    jojo: "".concat(window.location.origin, "/act2/qwerup")
  },
  // 小程序配置Key
  miniProgramConfigKey: {
    jojoup: 'jojoupMiniProgramConfig',
    beans: 'miniProgramConfig',
    doudou: 'miniProgramConfig',
    jojo: 'miniProgramConfig'
  },
  // 小程序配置Key2
  miniProgramConfigKey2: {
    jojoup: 'jojoupMiniProgramConfig',
    beans: 'addTeacherMiniProgram',
    doudou: 'addTeacherMiniProgram',
    jojo: 'addTeacherMiniProgram'
  },
  // 小程序信息（复用上面的配置）
  minipInfo: getMiniProgramInfo(),
  // 包名配置
  packageName: {
    jojoup: 'mp.mohezi.JoJoUp',
    beans: 'mp.mohezi.beans',
    doudou: 'mp.tinkzo.pico',
    jojo: 'mp.tinman.JoJoRead',
    zzx: 'mp.f2so.echo'
  },
  accountConfig: getAccountConfig(),
  delivererConfig: getNvwaConfig(),
  customerTransform: {
    jojoup: "".concat(window.location.origin, "/mall/market/transform/customerCenter"),
    beans: "".concat(window.location.origin, "/transform/customerCenter"),
    doudou: "".concat(window.location.origin, "/transform/customerCenter"),
    jojo: "".concat(window.location.origin, "/transform/customerCenter")
  },
  title: {
    jojoup: !isInJoJoUpApp && isIOSDevice ? '周周学' : 'JOJOUP',
    jojo: '叫叫',
    beans: '绿豆',
    doudou: '绿豆豆乐园',
    zzx: '周周学'
  },
  logo: {
    jojoup: !isInJoJoUpApp && isIOSDevice ? 'https://design.zzx.cdyanhezi.cn/library/marketing/0.5.4/zzx_icon.202688122529.png' : 'https://design.tinman.cn/library/marketing/0.4.6/up_p_icon3.202661871931.png',
    jojo: 'https://design.tinman.cn/library/marketing/0.4.6/p_icon3.202661871930.png',
    beans: 'https://design.tinman.cn/library/marketing/0.2.9/icon.202632423550.png',
    matrix: 'https://design.tinman.cn/library/marketing/0.4.6/p_icon3.202661871930.png',
    doudou: 'https://design.dd.shushengdu.com/library/marketing/0.2.9/icon.202632423550.png',
    zzx: 'https://design.zzx.cdyanhezi.cn/library/marketing/0.5.4/zzx_icon.202688122529.png'
  },
  loadingImg: {
    jojoup: !isInJoJoUpApp && isIOSDevice ? 'https://design.zzx.cdyanhezi.cn/library/marketing/0.3.8/zzxloading_1.2026611124454.gif' : 'https://design.tinman.cn/library/marketing/0.3.0/loading_2_1.202632424055.gif',
    beans: 'https://design.tinman.cn/library/marketing/0.3.6/lvdouloading_7.202641055927.gif',
    doudou: 'https://design.dd.shushengdu.com/library/marketing/0.3.6/lvdouloading_7.202641055927.gif',
    jojo: 'https://design.tinman.cn/library/marketing/0.3.0/loading_2.202632424055.gif',
    zzx: 'https://design.zzx.cdyanhezi.cn/library/marketing/0.3.8/zzxloading_1.2026611124454.gif'
  },
  emptyImg: {
    jojoup: !isInJoJoUpApp && isIOSDevice ? 'https://design.zzx.cdyanhezi.cn/library/public/3.0.8/zzx_empty.202661162948.png' : 'https://design.tinman.cn/library/marketing/0.3.1/jojoup-img-rest.20263242591.png',
    beans: 'https://design.tinman.cn/library/marketing/0.3.3/empty.202632474428.png',
    doudou: 'https://design.dd.shushengdu.com/library/marketing/0.3.3/empty.202632474428.png',
    jojo: 'https://design.tinman.cn/library/marketing/0.3.1/jojo-img-rest.20263242590.png',
    zzx: 'https://design.zzx.cdyanhezi.cn/library/public/3.0.8/zzx_empty.202661162948.png'
  },
  errorImg: {
    jojoup: !isInJoJoUpApp && isIOSDevice ? 'https://design.zzx.cdyanhezi.cn/library/public/3.0.8/zzx_empty.202661162948.png' : 'https://design.tinman.cn/library/marketing/0.3.1/jojoup-img-rest.20263242591.png',
    beans: 'https://design.tinman.cn/library/marketing/0.3.3/error.202632474429.png',
    doudou: 'https://design.dd.shushengdu.com/library/marketing/0.3.3/error.202632474429.png',
    jojo: 'https://design.tinman.cn/library/marketing/0.3.2/jojo_error.202632471451.png',
    zzx: 'https://design.zzx.cdyanhezi.cn/library/public/3.0.8/zzx_empty.202661162948.png'
  },
  // Schema 跳转配置
  schema: getAppSchema()
}; // ========== 导出最终枚举 ==========

export var enums = {
  addTeacherPath: getEnvConfig(envConfigMap.addTeacherPath),
  localBaseUrl: getEnvConfig(envConfigMap.localBaseUrl),
  miniProgramConfigKey: getEnvConfig(envConfigMap.miniProgramConfigKey),
  miniProgramConfigKey2: getEnvConfig(envConfigMap.miniProgramConfigKey2),
  minipInfo: getEnvConfig(envConfigMap.minipInfo),
  packageName: getEnvConfig(envConfigMap.packageName),
  accountConfig: getEnvConfig(envConfigMap.accountConfig),
  delivererConfig: getEnvConfig(envConfigMap.delivererConfig),
  customerTransform: getEnvConfig(envConfigMap.customerTransform),
  loadingImg: getEnvConfig(envConfigMap.loadingImg),
  emptyImg: getEnvConfig(envConfigMap.emptyImg),
  errorImg: getEnvConfig(envConfigMap.errorImg),
  title: getEnvConfig(envConfigMap.title),
  logo: getEnvConfig(envConfigMap.logo),
  schema: getEnvConfig(envConfigMap.schema)
};